import { DurationFormat } from "./index.js";
import { shouldPolyfill } from "./should-polyfill.js";
if (typeof Intl === "undefined") {
	if (typeof window !== "undefined") {
		Object.defineProperty(window, "Intl", { value: {} });
	} else if (typeof global !== "undefined") {
		// @ts-ignore we don't include @types/node so global isn't a thing
		Object.defineProperty(global, "Intl", { value: {} });
	}
}
if (shouldPolyfill()) {
	Object.defineProperty(Intl, "DurationFormat", { value: DurationFormat });
}
